import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import {
    Content
} from './UpcomingSick.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import PlanedAbsenceBlock from './PlanedAbsenceBlock';
import Cross_Icon from "@assets/svg/match/missing.svg";
import { BoxTop, Popup, PopupBox } from '@components/Redeem/Redeembackup.styled';

interface IProps { studentId: string, sickEvents: any, updateSickEvents: () => void, editSickEvent: (event) => void }

export const UpcomingSick = (props: IProps) => {
    const { client } = useStore();
    const [open, setOpen] = useState(false)
    const openRef = useRef(null)
    const i18n = useI18n();
    const [show, setShow] = useState(false)
    const [id, setId] = useState(null)

    const showPopup = (id) => {
        setId(id)
        setShow(true)
    }

    const hidePopup = () => {
        setId(null)
        setShow(false)
    }

    const deletePlannedAbsence = async () => {
        setShow(false)
        setId(null)
        await db.deleteSickEvent4Student(id)
        props.updateSickEvents()
    }

    return (<>

        <Content>
            <Popup show={show}>
            <PopupBox>
                <BoxTop>
                    <span>{i18n.t("confirm")}</span>
                    <button onClick={hidePopup}>
                        <Cross_Icon />
                    </button>
                </BoxTop>
                <span></span>
                <p>{i18n.t("delete-scheduled-absence")}</p>
                <div>
                    <button onClick={hidePopup}>{i18n.t("cancel")}</button>
                    <button onClick={deletePlannedAbsence}>{i18n.t("ok")}</button>
                </div>
            </PopupBox>
        </Popup>
            {props?.sickEvents?.map((l, index) => {
                return <PlanedAbsenceBlock edit={props.editSickEvent} delete={showPopup} key={"absenceblock_" + index} tags={l.tags} absenceId={l.absenceId} date={l.date} text={l.text} timeblocks={l.timeblocks} days={l.days} />
            })}
        </Content>
    </>);
};

export default UpcomingSick;
